import Dashboard from "../../layouts/Dashboard";
import Customers from "../../views/Customers";
import {authGuard} from "../../auth";
import CustomerCreate from "../../views/CustomerCreate";
import CustomerView from "../../views/CustomerView";


const routes = [
    {
        path: '/customers',
        name: 'customers',
        component: Customers,
        beforeEnter: authGuard,
        meta: { layout: Dashboard },
    },
    {
        path: '/customer/create',
        name: 'customer-create',
        component: CustomerCreate,
        beforeEnter: authGuard,
        meta: { layout: Dashboard },
    },
    {
        path: '/customer/:id',
        name: 'customer-view',
        component: CustomerView,
        beforeEnter: authGuard,
        meta: { layout: Dashboard },
    },
]

export default routes.map(route => {
    const meta = {
        layout: Dashboard
    }
    return { ...route, meta }
})